import Expandable from './utilities/expandable';

// Import functional JS for blocks
import '../../blocks/tabbed/frontend';
import '../../blocks/pricing/frontend';
import '../../blocks/dropdown-map/frontend';

window.kaplanBlocks = window.kaplanBlocks ?? {};
window.kaplanBlocks.Expandable = Expandable;

// Get all the different expandable elements.
const accordions = document.querySelectorAll( '.kaplan-accordion, .kaplan-accordion-faq__question, .kaplan-room-card' );

/* Group all the expandable elements with the
 * class .kaplan-expandable.
 *
 * It had to be done in two separate forEach to avoid
 * breking the loop index.
*/
accordions.forEach( ( accordion ) => {
	accordion.classList.add( 'kaplan-expandable' );
} );

// Set up the expandable functionality.
accordions.forEach( ( accordion ) => {
	new Expandable( accordion );
} );

// Set up carousels.
const { Carousel } = window.kaplanBlocks;
const carousels = document.querySelectorAll( '.kaplan-carousel' );
if ( Carousel && carousels.length ) {
	const options = {
		classes: {
			arrows: 'kaplan-carousel__arrows',
			arrow: 'kaplan-carousel__arrow',
			prev: 'kaplan-carousel__prev',
			next: 'kaplan-carousel__next',
		},
	};

	carousels.forEach( ( carousel ) => {
		const track = carousel.querySelector( '.kaplan-carousel__track' );
		const slides = carousel.querySelectorAll( '.kaplan-carousel__list > *' );
		if ( slides.length < 2 ) {
			return;
		}

		const container = document.createElement( 'div' );
		container.classList.add( 'splide' );
		container.appendChild( track );
		track.classList.add( 'splide__track' );
		track.firstElementChild.classList.add( 'splide__list' );

		Object.keys( carousel.dataset ).forEach( key => container.dataset[ key ] = carousel.dataset[ key ] );

		carousel.appendChild( container );

		slides.forEach( ( slide ) => {
			slide.classList.add( 'splide__slide' );
		} );

		new Carousel( container, options );

		carousel.classList.add( 'kaplan-carousel-active' );
	} );
}

// Set up galleries.
const galleries = document.querySelectorAll( '.wp-block-gallery' );
if ( galleries.length ) {
	const { Carousel } = window.kaplanBlocks;

	const options = {
		arrows: false,
		classes: {
			arrows: 'kaplan-carousel__arrows',
			arrow: 'kaplan-carousel__arrow',
			prev: 'kaplan-carousel__prev',
			next: 'kaplan-carousel__next',
		},
		fixedWidth: '100%',
		showNumbers: true,

		// Mobile-only carousel.
		breakpoints: {
			720: {
				destroy: true,
			},
		},
		mediaQuery: 'min',
	};

	const wrapGalleryForSplide = ( gallery ) => {
		const carousel = document.createElement( 'div' );
		carousel.classList.add( 'kaplan-carousel', 'kaplan-carousel-gallery' );

		const splide = document.createElement( 'div' );
		splide.classList.add( 'splide' );

		const track = document.createElement( 'div' );
		track.classList.add( 'splide__track' );

		gallery.parentNode.insertBefore( carousel, gallery );
		track.appendChild( gallery );
		splide.appendChild( track );
		carousel.appendChild( splide );

		return splide;
	};

	galleries.forEach( ( gallery ) => {
		gallery.classList.add( 'splide__list' );

		gallery.querySelectorAll( ':scope > .wp-block-image' ).forEach( ( image ) => {
			image.classList.add( 'splide__slide' );
		} );

		new Carousel( wrapGalleryForSplide( gallery ), options );
	} );
}

// Form styling.
if ( document.querySelector( '.site-main > .kaplan-embedded-form, .site-main > .kaplan-formstack-form' ) ) {
	document.body.classList.add( 'has-grey-15-background-color' );
}

// Copy to clipboard room id.
const $roomCards = document.querySelectorAll( '.wp-block-kaplan-room-card' );
const $startDateFilter = document.getElementById( 'startDateFilter' );
const $contractLengthFilter = document.getElementById( 'contractLengthFilter' );
$roomCards.forEach( ( roomCard ) => {
	// Apply the click event to the share button.
	const shareButtons = roomCard.querySelectorAll( '.button-share' );
	shareButtons.forEach( ( shareButton ) => {
		shareButton.addEventListener( 'click', evt => {
			let url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
			const roomId = roomCard.id;

			if ( $startDateFilter === null || $contractLengthFilter === null ) {
				alert( 'There was an error.' );
			}

			if ( ( $startDateFilter !== null && $startDateFilter.value !== '0' )
				&& ( $contractLengthFilter !== null && $contractLengthFilter.value !== '0' ) ) {
				url += '?startdate=' + $startDateFilter.value + '&contractlength=' + $contractLengthFilter.value + '#' + roomId;
			} else {
				url += '#' + roomId;
			}

			// Copy the URL in the clipboard.
			navigator.clipboard.writeText( url ).then(
				() => {
					alert( 'Link was copied to the clipboard.' );
				},
				() => {
					alert( 'There was an error.' );
				}
			  );
		} );
	} );

} );

document.addEventListener( 'DOMContentLoaded', function () {
	const reloadElement = document.querySelector( 'p[data-reload-url]' );
	if ( reloadElement ) {
		const reloadUrl = reloadElement.getAttribute( 'data-reload-url' );
		setTimeout( function () {
			window.location.href = reloadUrl;
		}, 5000 );
	}
} );

